<template>
  <FourElement />
  <div class="collection-container">
    <Filter />
    <List />
    <div v-if="dataSource && dataSource.length > 0">
      <div class="fs14 lh30 fl" style="color: #999999;">
        {{
          `共 ${pagination.total} 条记录，第${pagination.pageNum} / ${~~(
            pagination.total / pagination.pageSize
          ) +
            (pagination.total % pagination.pageSize
              ? 1
              : pagination.total === 0
              ? 1
              : 0)}页`
        }}
      </div>
      <div
        style="display: flex; flex-direction: row; float: right; padding-bottom: 50px;"
      >
        <a-pagination
          v-if="pagination.pageSize"
          class="mr20"
          v-model:current="pagination.pageNum"
          :total="pagination.total"
          v-model:pageSize="pagination.pageSize"
          :showTotal="() => false"
          :showSizeChanger="false"
          @change="initList"
        />
        <a-select
          class="mr10"
          style="min-width: 80px;"
          v-model:value="pagination.pageSize"
          @change="initList"
          placeholder="条"
          :options="[
            { value: 10, label: 10 },
            { value: 20, label: 20 },
            { value: 30, label: 30 },
            { value: 40, label: 40 },
            { value: 50, label: 50 }
          ]"
        >
        </a-select>
        <div class="lh30 mr10">条/页</div>
        <div class="lh30 mr10">跳转至</div>
        <a-input-number
          class="mr10"
          style="width: 50px;"
          :value="pagination.pageNum"
          placeholder="页"
          :max="
            pagination.total <= pagination.pageSize
              ? 1
              : Math.ceil(pagination.total / pagination.pageSize)
          "
          :min="1"
          @change="watchPage"
        />
        <div class="lh30">页</div>
      </div>
    </div>
  </div>
  <Log />
  <AsyncModel v-if="asyncVisible !== 0" />
</template>
<script>
import { toRefs, reactive, provide, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import FourElement from './components/FourElement'
import Filter from './components/Filter'
import List from './components/List'
import Log from './components/Log'
import AsyncModel from './components/AsyncModel'
import useAPI from 'UseApi'
import { message } from 'ant-design-vue'
import moment from 'moment'
const {
  common_querySiteInfo_get_,
  col_deleteCol_post_,
  col_activeCol_post_,
  col_queryColLog_post_,
  mixCol_page_post_,
  mixCol_saveMixCol_post_,
  mixCol_remove_mixId_get_,
  mixCol_getMixColDetail_mixId_get_,
  mixCol_checkMixCol_post_,
  col_shopify_detail_page_post_,
  col_shopify_page_post_,
  col_shopify_batch_get_post_,
  col_shopify_sync_post_
} = useAPI(null, [3426, 4240, 5922, 6251])
import { downloadFile } from 'utils/file.js'
export default {
  components: {
    FourElement,
    Filter,
    List,
    Log,
    AsyncModel
  },
  setup() {
    const state = reactive({
      status: true,
      unAddQuery: {
        queryType: 0,
        search: null
      },
      addQuery: {
        queryType: 0,
        search: null
      },
      asyncNow: () => {
        let addAsyncDataSource_ = [...state.addAsyncDataSource],
          addAsyncDataSource = []
        addAsyncDataSource_.map(item => {
          addAsyncDataSource = [...addAsyncDataSource, item.shopifyCollectionId]
        })
        let params = {
          shopifyCollectionIds: addAsyncDataSource,
          status: state.status ? 1 : 0,
          ...state.searchParams
        }
        col_shopify_sync_post_(params, state)
      },
      addCol: (index, record) => {
        let asyncDataSource = [...state.asyncDataSource]
        asyncDataSource.splice(index, 1)
        state.asyncDataSource = asyncDataSource
        state.addAsyncDataSource = [...state.addAsyncDataSource, record]
      },
      backCol: (index, record) => {
        let addAsyncDataSource = [...state.addAsyncDataSource]
        addAsyncDataSource.splice(index, 1)
        state.addAsyncDataSource = addAsyncDataSource
        state.asyncDataSource = [...state.asyncDataSource, record]
      },
      addAsyncDataSource: [],
      asyncDataSource: [],
      changeVisible: () => {
        let search = state.addQuery.search
        let addAsyncDataSource = [...state.addAsyncDataSource]
        if (!search || search === '') {
          addAsyncDataSource.map(item => {
            item.search = true
          })
        } else {
          addAsyncDataSource.map(item => {
            if (item.shopifyCollectionId + '' === search + '') {
              item.search = true
            } else {
              item.search = false
            }
          })
        }
        state.addAsyncDataSource = addAsyncDataSource
      },
      asyncSearch: () => {
        col_shopify_batch_get_post_(state)
      },
      asyncPagination: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页的数量
        total: 0 // 总记录数
      },
      warningAlert: true,
      mixParams: {
        peerShowFlag: 0, // 分体是否一行展示，0-否，1-是
        mixId: null, // mixId，编辑时必传，新增不传
        colId: null // collectionId
      },
      mixPagination: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页的数量
        total: 0 // 总记录数
      },
      asyncVisible: 0,
      mixDetailVisible: false,
      downloadFun: async params => {
        await downloadFile(
          `${process.env.VUE_APP_COL}/col/shopify/export`,
          { ...params },
          { timeout: 5000 }
        )
          .then(() => {})
          .catch(() => {
            message.error('操作失败！')
          })
      },
      asyncVisibleChange: (asyncVisible = 0) => {
        state.asyncVisible = asyncVisible
        if (asyncVisible - 0 === 0) {
          state.logPagination = {
            pageNum: 1, // 当前页
            pageSize: 10, // 每页的数量
            total: 0 // 总记录数
          }
          state.addAsyncDataSource = []
          state.asyncDataSource = []
          state.unAddQuery = {
            queryType: 0,
            search: null
          }
          state.addQuery = {
            queryType: 0,
            search: null
          }
          state.status = true
        }
      },
      mixShowDetail: ({ mixId }) => {
        state.mixDetailVisible = true
        state.getMixDetail({ mixId })
      },
      checkMixCol: async (colId, mixType = 1) => {
        let params = {
          peerShowFlag: state.mixParams.peerShowFlag,
          ...state.searchParams,
          colId,
          mixType
        }
        if (state.mixParams.mixId !== null) {
          params.mixId = state.mixParams.mixId
        }
        const { success, retInfo } = await mixCol_checkMixCol_post_({
          ...params
        })

        if (success) {
          console.log('')
        } else {
          if (state.warningAlert) {
            if (retInfo === '' || retInfo === null) return
            state.warningAlert = false
            message.warning(retInfo)
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
        }
      },
      addMixData: () => {
        state.mixDetailVisible = true
        state.mixParams = {
          peerShowFlag: 0, // 分体是否一行展示，0-否，1-是
          mixId: null, // mixId，编辑时必传，新增不传
          colId: null // collectionId
        }
        state.mixDataSource = [
          {
            priority: null,
            colId: null,
            crossNum: null
          }
        ]
      },
      cancelEditMix: () => {
        state.mixDetailVisible = false
        state.mixParams = {
          peerShowFlag: 0, // 分体是否一行展示，0-否，1-是
          mixId: null, // mixId，编辑时必传，新增不传
          colId: null // collectionId
        }
        state.mixDataSource = [
          {
            priority: null,
            colId: null,
            crossNum: null
          }
        ]
      },
      mixColDetailList: [{ colId: null, crossNum: null, priority: null }],
      getMixDetail: async ({ mixId }) => {
        const {
          success,
          data,
          retInfo
        } = await mixCol_getMixColDetail_mixId_get_({
          mixId
        })
        if (success) {
          const { mixColDetailList, mixId, peerShowFlag, colId } = data
          state.mixParams = { ...state.mixParams, mixId, peerShowFlag, colId }
          if (mixColDetailList.length === 0) {
            state.mixDataSource = [
              {
                priority: null,
                colId: null,
                crossNum: null
              }
            ]
          } else {
            state.mixDataSource = [...mixColDetailList]
          }
        } else {
          if (state.warningAlert) {
            if (retInfo === '' || retInfo === null) return
            state.warningAlert = false
            message.warning(retInfo)
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
        }
      },
      relieveMix: async ({ id = null }) => {
        if (!id) {
          message.warning('未传入ID！')
          return
        }
        const { retInfo, success } = await mixCol_remove_mixId_get_({
          mixId: id
        })
        if (success) {
          message.success(retInfo)
          state.getMixList()
        } else {
          if (state.warningAlert) {
            if (retInfo === '' || retInfo === null) return
            state.warningAlert = false
            message.warning(retInfo)
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
        }
      },
      removeMixDataSource: index => {
        let mixDataSource = [...state.mixDataSource]
        mixDataSource.splice(index, 1)
        state.mixDataSource = [...mixDataSource]
      },
      saveMixCol: async (successTitle = '修改') => {
        let hasError = false
        if (state.mixParams.colId === '' || state.mixParams.colId === null) {
          if (state.warningAlert) {
            hasError = true
            state.warningAlert = false
            message.warning('混合商品Collection ID必填')
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
          return
        }
        let mixDataSource = [...state.mixDataSource]
        mixDataSource.map((v, index = 0) => {
          v.priority = index - 0 + 1
          if (v.colId === '' || v.colId === null) {
            if (state.warningAlert) {
              state.warningAlert = false
              message.warning('collection ID必填')
              setTimeout(() => {
                state.warningAlert = true
              }, 3000)
            }
            hasError = true
            return
          }
          if (
            v.crossNum === '' ||
            v.crossNum === null ||
            v.crossNum - 0 === 0
          ) {
            if (state.warningAlert) {
              state.warningAlert = false
              message.warning('穿插个数必填')
              setTimeout(() => {
                state.warningAlert = true
              }, 3000)
            }
            hasError = true
            return
          }
        })
        if (!state.mixParams.colId || state.mixParams.colId === '') {
          if (state.warningAlert) {
            state.warningAlert = false
            message.warning('未填写混合商品Collection ID！')
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
          hasError = true
          return
        }
        if (hasError) {
          return
        }
        const { success, retInfo } = await mixCol_saveMixCol_post_({
          ...state.mixParams,
          ...state.searchParams,
          mixColDetailList: [...mixDataSource]
        })
        if (success) {
          message.success(`${successTitle}成功!`)
          state.getMixList()
        } else {
          if (state.warningAlert) {
            if (retInfo === '' || retInfo === null) return
            state.warningAlert = false
            message.warning(retInfo)
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
        }
      },
      getMixList: async () => {
        const { success, data, retInfo } = await mixCol_page_post_({
          ...state.searchParams,
          ...state.mixPagination
        })
        if (success) {
          const { list, pageNum, pageSize, total } = data
          state.mixPagination = { pageNum, pageSize, total }
          state.mixDataList = list
          if (list.length === 0) {
            state.mixDetailVisible = true
          } else {
            state.mixDetailVisible = false
          }
        } else {
          if (state.warningAlert) {
            if (retInfo === '' || retInfo === null) return
            state.warningAlert = false
            message.warning(retInfo)
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
        }
      },
      mixDataList: [],
      addMixDataSource: (index = 0) => {
        let mixDataSource = [...state.mixDataSource]
        mixDataSource.splice(index + 1, 0, {
          priority: null,
          colId: null,
          crossNum: null
        })
        state.mixDataSource = mixDataSource
      },
      mixDataSource: [
        {
          priority: null,
          colId: null,
          crossNum: null
        }
      ],
      checkLength: (key, len, text) => {
        switch (key) {
          case 'colId':
            if (
              state.mixParams.colId === null ||
              state.mixParams.colId === ''
            ) {
              message.warning('请填写混合商品Collection ID!')
            } else {
              state.mixParams.colId = state.mixParams.colId.substring(0, len)
            }
            break
          case 'colId_':
            if (text.colId === null || text.colId === '') {
              message.warning('请填写Collection ID!')
            } else {
              text.colId = text.colId.substring(0, len)
            }
            break
          case 'crossNum':
            if (
              text.crossNum === null ||
              text.crossNum === '' ||
              text.crossNum === 0
            ) {
              message.warning('穿插个数必填!')
            } else {
              text.crossNum = text.crossNum.substring(0, len)
            }
            break
        }
      },
      mixIndex: 0,
      mixCustomRow: (row, index) => {
        return {
          draggable: true,
          props: {
            draggable: true
          },
          sourceRowIndex: 0,
          onDragstart: e => {
            e.stopPropagation()
            state.mixIndex = index
          },
          onDragover: e => {
            e.preventDefault()
          },
          onDrop: e => {
            e.stopPropagation()
            const row = state.mixDataSource.splice(state.mixIndex, 1)
            state.mixDataSource.splice(index, 0, ...row)
          }
        }
      },
      clicked: false,
      hovered: false,
      handleHoverChange: visible => {
        state.clicked = false
        state.hovered = visible
      },
      handleClickChange: visible => {
        state.clicked = visible
        state.hovered = false
      },
      hide: () => {
        state.clicked = false
        state.hovered = false
      },
      watchPage: e => {
        state.pagination.pageNum = e
        state.initList()
      },
      searchInputLengthCut: ({ val = null, key = null }) => {
        if (!val) return
        let value = val.split('').splice(0, 200)
        state[key].search = value.join('')
      },
      inputLengthCut: ({ val = null, key = null, len = 0 }) => {
        if (!val) return
        let value = val.split('').splice(0, len)
        state.postParams[key] = value.join('')
        if (key === 'seoTitle') {
          console.log('val', val)
        }
        if (key === 'name') {
          // 如果是修改标题
          if (state.postParams.colSeo && state.postParams.colSeo.seoUrl) {
            state.inputLengthCut({
              val: state.postParams.colSeo.seoUrl,
              type: 'colSeo',
              key: 'seoUrl',
              len: 255,
              reg: true
            })
          }

          if (state.postParams.colSeo && state.postParams.colSeo.seoTitle) {
            state.inputLengthCut({
              val: state.postParams.colSeo.seoTitle,
              type: 'colSeo',
              key: 'seoTitle',
              len: 70
            })
          }
        }
      },
      logVisible: false, // 日志弹窗
      col_activeCol_post: params => {
        col_activeCol_post_(params, state.initList)
      },
      col_queryColLog_post: params => {
        if (params.colId) {
          state.colId = params.colId
        }

        col_queryColLog_post_({ ...params }, state)
      },
      deleteFun: params => {
        col_deleteCol_post_(params, state.initList, state)
        params.showDel = false
      },
      value: null,
      route: useRoute(),
      router: useRouter(),
      jumpPage: (path, query) => {
        console.log('query ', query)
        state.router.push({ path, query })
      },
      dataSource: [],
      searchParams: {
        terminalId: 1,
        brandId: 1,
        channelId: 1,
        siteId: 1
      },
      brands: [],
      channels: [],
      sites: [],
      postParams: {
        colId: null, // 编码
        creatorName: null,
        seoUrl: null,
        shopifyColId: null,
        shopifyCollectionId: null,
        syncTimeBegin: null,
        syncTimeEnd: null,
        title: null,
        releationId: null // 关联终端编码
      },
      resetParams: () => {
        state.postParams = {
          colId: null, // 编码
          creatorName: null,
          seoUrl: null,
          shopifyColId: null,
          shopifyCollectionId: null,
          syncTimeBegin: null,
          syncTimeEnd: null,
          title: null,
          releationId: null // 关联终端编码
        }
        state.initList()
      },
      initLog: () => {
        col_shopify_page_post_(state)
      },
      changeFilterTime: timeSet => {
        state.postParams = {
          ...state.postParams,
          syncTimeBegin:
            timeSet === null || timeSet.length === 0
              ? null
              : moment(
                  new Date(timeSet[0]).getFullYear() +
                    '-' +
                    (new Date(timeSet[0]).getMonth() + 1 < 10
                      ? '0' + (new Date(timeSet[0]).getMonth() + 1)
                      : new Date(timeSet[0]).getMonth() + 1) +
                    '-' +
                    (new Date(timeSet[0]).getDate() < 10
                      ? '0' + new Date(timeSet[0]).getDate()
                      : new Date(timeSet[0]).getDate()) +
                    ' 00:00:01'
                ).format(),
          syncTimeEnd:
            timeSet === null || timeSet.length === 0
              ? null
              : moment(
                  new Date(timeSet[1]).getFullYear() +
                    '-' +
                    (new Date(timeSet[1]).getMonth() + 1 < 10
                      ? '0' + (new Date(timeSet[1]).getMonth() + 1)
                      : new Date(timeSet[1]).getMonth() + 1) +
                    '-' +
                    (new Date(timeSet[1]).getDate() < 10
                      ? '0' + new Date(timeSet[1]).getDate()
                      : new Date(timeSet[1]).getDate()) +
                    ' 23:59:59'
                ).format()
        }
      },
      pagination: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页的数量
        total: 0 // 总记录数
      },
      logList: [],
      logPagination: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页的数量
        total: 0 // 总记录数
      },
      initList: () => {
        if (state.route.query.terminalId) {
          state.searchParams.terminalId = state.route.query.terminalId - 0
        }
        if (state.route.query.brandId) {
          state.searchParams.brandId = state.route.query.brandId - 0
        }
        if (state.route.query.channelId) {
          state.searchParams.channelId = state.route.query.channelId - 0
        }
        if (state.route.query.siteId) {
          state.searchParams.siteId = state.route.query.siteId - 0
        }
        col_shopify_detail_page_post_(state)
      } // 初始化标题列表
    })
    onMounted(() => {
      console.log('state.route.query ', state.route.query)
      if (state.route.query.terminalId) {
        state.searchParams.terminalId = state.route.query.terminalId - 0
      }
      if (state.route.query.brandId) {
        state.searchParams.brandId = state.route.query.brandId - 0
      }
      if (state.route.query.channelId) {
        state.searchParams.channelId = state.route.query.channelId - 0
      }
      if (state.route.query.siteId) {
        state.searchParams.siteId = state.route.query.siteId - 0
        state.router.replace({ query: {} })
      }
      common_querySiteInfo_get_({
        state
      })
      state.initList()
    })
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
